var map = {
	"./812_otto_e_mezzo_bombana.jpg": "c625",
	"./a-ma_cultural_village.jpg": "156f",
	"./aji_mgm_cotai.jpg": "344e",
	"./alain_ducasse_at_morpheus.jpg": "2bf6",
	"./alto_de_coloane.jpg": "bcec",
	"./amaral_stone_at_the_lin_fong_temple.jpg": "f9c5",
	"./antonio.jpg": "8425",
	"./at_the_top_of_ruins_of_st_pauls.jpg": "9071",
	"./barrier_gate.jpg": "3a6a",
	"./camoens_grotto_.jpg": "cbb7",
	"./casa_garden_and_fundacao_oriente_.jpg": "1c24",
	"./cineteatro_alegria.jpg": "4f94",
	"./cotai_strip.jpg": "770e",
	"./east_india_company_cemetery_old_protestant_cemetery.jpg": "d005",
	"./firecracker_factories.jpg": "fd8e",
	"./graffiti_walls_at_animarte_nam_van.jpg": "63fa",
	"./guia_hill.jpg": "1077",
	"./hac_sa_reservoir_country_park.jpg": "1601",
	"./la_famiglia.jpg": "d852",
	"./lai_heen_galaxy.jpg": "282c",
	"./lou_lim_ioc_gardens.jpg": "53f9",
	"./macaos_scenic_side.jpg": "b321",
	"./macau_design_centre.jpg": "2eca",
	"./mong_ha_fort.jpg": "9ffe",
	"./moorish_barracks.jpg": "e7de",
	"./panda_pavilion.jpg": "69ab",
	"./patio_de_chon_sau.jpg": "0d98",
	"./penha_hill.jpg": "7104",
	"./pou_tai_monastery_and_pou_tai_un_temple.jpg": "4e75",
	"./riquexo.jpg": "8987",
	"./rua_da_felicidade.jpg": "d6e1",
	"./st_lazarus_district.jpg": "4f11",
	"./sw_steakhouse_wynn_palace.jpg": "92c4",
	"./taipa_village_art_space.jpg": "788d",
	"./the_eight_grand_lisboa.jpg": "e294",
	"./the_golden_peacock_venetian_macao.jpg": "31e2",
	"./the_museum_of_the_holy_house_of_mercy_of_macau.jpg": "828c",
	"./three_lamps_district.jpg": "a56f",
	"./travessa_da_paixao.jpg": "bb94",
	"./va_kio_yat_po_offices.jpg": "3feb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bc1";